import { NousWrapper } from "./Nous.style";
import { useState, useEffect, useRef } from "react";
import Aos from "aos";
import { Button, Carousel, Select } from "antd";
import Footer from "../../components/global/Footer/Footer";
import { useMediaQuery } from "react-responsive";
import Link from "next/link";
import Profile from "../../components/Nous/Profile/Profile";
import { NextSeo } from "next-seo";
import Bloc from "../../components/Bloc/Bloc";
import batiment from "../../../public/nous/batiment.jpeg";
import plante from "../../../public/nous/plante.png";
import mint from "../../../public/nous/mint.jpg";
import zoe from "../../../public/nous/zoe.webp";
import serveur from "../../../public/nous/serveur.png";
import Image from "next/image";

export default function Nous({ users }) {
  const [collaboratorFilter, setCollaboratorFilter] = useState("consultants");
  const carousel = useRef();
  const { Option } = Select;

  const isDesktop = useMediaQuery({ minWidth: 1024 });
  useEffect(() => {
    Aos.init({ duration: 1500 });
  }, []);

  useEffect(() => {
    if (carousel?.current) {
      switch (collaboratorFilter) {
        case "consultants":
          carousel.current.goTo(0);
          break;
        case "negotiators":
          carousel.current.goTo(1);
          break;
        case "supports":
          carousel.current.goTo(2);
          break;
        case "gestion":
          carousel.current.goTo(3);
          break;
      }
    }
  }, [collaboratorFilter]);

  const collaborators = {
    consultants: {
      title: "Vos conseillers",
      collaborators: [
        {
          name: "Benoît Cardinault",
          phone: "06 01 73 09 58",
          email: "bcardinault@easycapital.fr",
          picture: "espace_client/photos%20collaborateurs/adyj0ncopafd6vjhcjzn",
          linkedin:
            "https://www.linkedin.com/in/beno%C3%AEt-cardinault-b84bb321a/",
        },
        {
          name: "Jérôme Cardinault",
          phone: "06 66 24 84 03",
          email: "jcardinault@easycapital.fr",
          picture: "espace_client/photos%20collaborateurs/hfnbkikfbuh3bulbjtfb",
          linkedin:
            "https://www.linkedin.com/in/j%C3%A9r%C3%B4me-cardinault-0aa16945/",
        },
        {
          name: "Lili-Rose Beaudouin",
          phone: "07 80 91 01 50",
          email: "lrbeaudouin@easycapital.fr",
          picture: "espace_client/photos%20collaborateurs/r9s0dqrhpwgwiiywo98b",
          linkedin: "https://www.linkedin.com/in/lili-rose-b-b31903141/",
        },
        {
          name: "Rémi Prin",
          phone: "07 69 16 67 29",
          email: "rprin@easycapital.fr",
          picture: "espace_client/photos%20collaborateurs/w2siohdjjprihngnjefc",
          linkedin: "https://www.linkedin.com/in/remiprin/",
        },
        {
          name: "Nabil Sabour",
          phone: "07 64 71 21 56",
          email: "nsabour@easycapital.fr",
          picture: "espace_client/photos%20collaborateurs/ljhpskdrgktb6e18ajjr",
          linkedin: "https://www.linkedin.com/in/nabil-sabour-6538b18b/",
        },
        {
          name: "Ghita Gherras",
          phone: "06 50 20 27 94",
          email: "ggherras@easycapital.fr",
          picture: "espace_client/photos%20collaborateurs/moiqd6yohuyrlrvcknno",
          linkedin: "https://www.linkedin.com/in/ghita-gherras-38118a176/",
        },
        {
          name: "Cyrielle Blanchet",
          phone: "07 80 90 79 28 ",
          email: "cblanchet@easycapital.fr",
          picture: "espace_client/photos%20collaborateurs/a5lg4dkg7rlpe1bp5pju",
          linkedin: "https://www.linkedin.com/in/cyrielle-blanchet-3532321b1/",
        },
      ],
    },
    negotiators: {
      title: "Vos négociateurs",
      collaborators: [
        {
          name: "Emmanuel Genet",
          phone: "07 80 91 06 26",
          email: "egenet@easycapital.fr",
          picture: "espace_client/photos%20collaborateurs/pbnzwnobzdlpmweilhgg",
          linkedin: "https://www.linkedin.com/in/emmanuel-genet-84b56b139/",
        },
        {
          name: "Sarah Hayoun",
          phone: "07 80 90 77 30",
          email: "shayoun@easycapital.fr",
          picture: "espace_client/photos%20collaborateurs/ds1izr7spw9he7zasx1w",
          linkedin: "https://www.linkedin.com/in/sarah-hayoun-4a10841b6/",
        },
        {
          name: "Thibault Muller",
          phone: "07 80 90 10 71",
          email: "tmuller@easycapital.fr",
          picture: "espace_client/photos%20collaborateurs/ka0dazawjkpri91b5xcx",
          linkedin: "https://www.linkedin.com/in/thibaultmuller37/",
        },
        {
          name: "Mathis Merrouk",
          phone: "06 64 77 61 14",
          email: "mmerrouk@easycapital.fr",
          picture: "espace_client/photos%20collaborateurs/eezmcbqxhwb0w68gzplj",
          linkedin: "https://www.linkedin.com/in/mathis-merrouk/",
        },
        {
          name: "Adrien Moreno",
          phone: "06 59 29 82 96",
          email: "amoreno@easycapital.fr",
          picture: "espace_client/photos%20collaborateurs/r8s7zjhdszaqev856abo",
          linkedin: "",
        },
      ],
    },
    supports: {
      title: "Votre support",
      collaborators: [
        {
          name: "Vy Nguyen-Viola",
          phone: "07 80 90 53 37",
          email: "vnguyen@easycapital.fr",
          picture: "espace_client/photos%20collaborateurs/vnkyzwy6buefznub3bve",
          linkedin: "https://www.linkedin.com/in/hongvy-nguyen/",
        },
        {
          name: "Elie Boury",
          phone: "",
          email: "eboury@easycapital.fr",
          picture: "espace_client/photos%20collaborateurs/flzdzwmnegod9nopsfc7",
          linkedin: "https://www.linkedin.com/in/elie-boury-70a040151/",
        },
      ],
    },
  };

  return (
    <NousWrapper>
      <NextSeo
        title={"Qui sommes-nous ?"}
        description={
          "Nous sommes convaincus que la gestion de votre patrimoine doit être simple, accessible et agréable.\n\n" +
          "Depuis 2008, nous nous chargeons de la partie chronophage et complexe pour vous permettre de vous concentrer sur l'essentiel : faire les choix adaptés à votre situation en étant bien informés.\n\n" +
          "Nos algorithmes intelligents ont été pensé pour vous aider à faire les bons choix mais nous avons à coeur de vous proposer une équipe dynamique, formée et disponible pour vous accompagner dans vos décisions d'investissements.\n\n" +
          "Mise à part notre solution, qui peut se targuer d'avoir un capital totalement indépendant des banques, assureurs ou promoteurs ? C'est pourtant un point essentiel pour avoir une vision éclairée de toutes les solutions adaptées qui s'offrent à vous et ce, en toute transparence."
        }
      />
      <div className="img_team">
        <h1>Qui sommes-nous ?</h1>
        {isDesktop && (
          <Image
            src={batiment}
            alt="Bâtiment Easy Capital"
            placeholder="blur"
            priority
          />
        )}
      </div>
      <div className="section2">
        <div className="txt">
          Nous sommes convaincus que la gestion de votre patrimoine doit être
          simple, accessible et agréable. <br /> <br /> Depuis 2008, nous nous
          chargeons de la partie chronophage et complexe pour vous permettre de
          vous concentrer sur l'essentiel : faire les choix adaptés à votre
          situation en étant bien informés. <br />
          <br /> Nos algorithmes intelligents ont été pensé pour vous aider à
          faire les bons choix mais nous avons à coeur de vous proposer une
          équipe dynamique, formée et disponible pour vous accompagner dans vos
          décisions d'investissements. <br />
          <br /> Mise à part notre solution, qui peut se targuer d'avoir un
          capital totalement indépendant des banques, assureurs ou promoteurs ?
          C'est pourtant un point essentiel pour avoir une vision éclairée de
          toutes les solutions adaptées qui s'offrent à vous et ce, en toute
          transparence.
        </div>
        <Button className="btn" id="notreequipe">
          <Link href="/start">Débuter ma simulation</Link>
        </Button>
      </div>
      <div className="filters">
        {isDesktop ? (
          ["consultants", "negotiators", "supports"].map((filter, index) => {
            return (
              <Button
                onClick={() => setCollaboratorFilter(filter)}
                className={collaboratorFilter == filter ? "selected" : ""}
                key={index}
              >
                {collaborators[filter].title}
              </Button>
            );
          })
        ) : (
          <Select
            onChange={(value) => setCollaboratorFilter(value)}
            defaultValue={"consultants"}
          >
            {["consultants", "negotiators", "supports"].map((filter, index) => {
              return (
                <Option
                  selected={collaboratorFilter == filter ? "selected" : ""}
                  key={index}
                  value={filter}
                >
                  {collaborators[filter].title}
                </Option>
              );
            })}
          </Select>
        )}
      </div>
      <Carousel ref={carousel}>
        {["CGP", "Agent Immobilier", "Ressources Humaines"].map((categorie) => {
            
          let nameCate = ""
          if (categorie == "CGP") {
            nameCate = "Vos conseillers"
          } else if (categorie == "Agent Immobilier") {
            nameCate = "Vos négociateurs"
          } else if (categorie == "Ressources Humaines") {
            nameCate = "Votre support"
          }

          return (
            <>
              <h2 className="collaboratorsTitle">{nameCate}</h2>
              <hr className="collaboratorsRow" />
              {isDesktop ? (
                <div className="collaboratorsWrapper">
                  {users.map((user, index) => {
                    if (user.roles.includes(categorie) && user.ex == 0)
                      return (
                        <Profile
                          key={index}
                          className={
                            index > 1 || categorie == "Vos conseillers"
                              ? "three"
                              : index
                              ? "two right"
                              : "two left"
                          }
                          collaborator={user}
                        />
                      );
                  })}
                </div>
              ) : (
                <div className="collaboratorsWrapper">
                  {collaboratorSection.collaborators
                    .filter(
                      (collaborator) => Object.values(collaborator).length
                    )
                    .map((collaborator, index) => {
                      return (
                        <Profile key={index} collaborator={collaborator} />
                      );
                    })}
                </div>
              )}
            </>
          );
        })}
      </Carousel>
      <div className="section3">
        {isDesktop && (
          <div className="gauche">
            <Image src={plante} alt="Visons une approche plus responsable" />
          </div>
        )}
        <div className="droite">
          <h2 className="title">
            Transparence et conseil ne suffisent plus. Visons une approche +
            responsable.
          </h2>
          <div className="txt">
            Diriger nos choix d'entreprises vers des valeurs qui nous tiennent à
            coeur, c'est notre philosophie. Equité, esprit d'équipe, zéro déchet
            et zéro CO2 sont nos objectifs internes. <br /> <br /> Pour vous,
            nous réservons une approche globale dédiée aux investissements
            responsables mais toujours avec une vision globale et transparente.
          </div>
        </div>
      </div>
      <div className="blocs">
        <Bloc
          title={<h3 className="title">Une énergie propre</h3>}
          img={mint}
          className="eolienne"
          btn={""}
          isDesktop={isDesktop}
          reverse
        >
          Nous avons décidé de passer à l'action pour générer l'énergie
          nécessaire à nos locaux. L'installation de panneaux solaires nous
          permet de produire 25% d'énergie verte. Pour compléter, nous avons
          choisi un fournisseur d'électricité 100% verte. Nous croyons qu'il est
          primordiale d'agir à notre échelle pour préserver notre planète.
        </Bloc>
        <Bloc
          title={<h3 className="title">Des véhicules électriques</h3>}
          img={zoe}
          className="voiture"
          btn={""}
          isDesktop={isDesktop}
        >
          Une bonne partie de nos rendez-vous se déroulent désormais à distance,
          en visio, réduisant ainsi le CO2 émis par les kilomètres non
          parcourus. Pour certains de nos métiers, ça n'est pas possible ! Nous
          avons fait le choix d'acheter des véhicules Renault Zoé parce que les
          batteries utilisent peu de matières rares et permettent ainsi un bilan
          carbone à ZERO pour nos trajets professionnels.
        </Bloc>
        <Bloc
          title={<h3 className="title">Des serveurs économes</h3>}
          img={serveur}
          btn={""}
          isDesktop={isDesktop}
          reverse
        >
          Nos serveurs sécurisés ne sont pas installés à l'autre bout du monde
          mais en France, à Clermont Ferrand. Nos partenaires utilisent des
          technologies de refroidissement les plus économes possibles notamment
          le free cooling utilisant l'air frais extérieur.
        </Bloc>
      </div>
      <div className="jobs">
        <h3 className="title">Jobs</h3>
        <div className="txt">
          Vous cherchez un job dans une équipe incroyable ?
        </div>
        <Button className="btn">
          <a
            href="https://www.linkedin.com/company/easy-capital/jobs/"
            target="_blank"
          >
            C'est parti
          </a>
        </Button>
      </div>
      <Footer />
    </NousWrapper>
  );
}
